import * as React from 'react';

import { PictureProfile } from '../../../../ResizedImage/PictureProfile.csharp';
import { PriceDisplay } from '../../PriceDisplay';
import { ResponsivePicture } from '../../ResponsivePicture/ResponsivePicture';
import { ResponsivePictureViewModel } from '../../ResponsivePicture/ResponsivePictureViewModel.csharp';

interface ViagraFormHeaderProps {
    profile: PictureProfile;
    image: ResponsivePictureViewModel;
    mainName: string;
    additionalName: string;
    price: number;
}

export const ViagraFormHeader = ({ profile, image, mainName, additionalName, price }: ViagraFormHeaderProps) => {
    return (
        <>
            <h4 className="ViagraForm__ContentHeader">Reseptfritt med veiledning</h4>
            <div className="ViagraForm__Product">
                <div className="ViagraForm__ProductImage">
                    <ResponsivePicture profile={profile} model={image} isLazyLoaded />
                </div>
                <div className="ViagraForm__ProductDetails">
                    <span className="ViagraForm__ProductBrand">{mainName}</span>
                    <span className="ViagraForm__ProductName">{additionalName}</span>
                </div>
                <span className="ViagraForm__ProductPrice">
                    <PriceDisplay price={price} roundUp />
                </span>
            </div>
        </>
    );
};
